export const decodeJwt = (token: string) => {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) {
      return null;
    }
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((char) => `%${('00' + char.charCodeAt(0).toString(16)).slice(-2)}`)
        .join(''),
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('JWT 디코딩 실패:', error);
    return null;
  }
};

export const isTokenExpired = (token: string, leewayMs = 0) => {
  const payload = decodeJwt(token);
  if (!payload?.exp) {
    return false;
  }
  const expiryTime = payload.exp * 1000;
  return expiryTime <= Date.now() + leewayMs;
};













